import React from "react";

import { StockPanel } from "./StockPanel";

export function ControlPanel() {
    return <StockPanel />;
}
